import React from "react"
import type { Product } from "../types"

interface ProductCardProps {
  product: Product
  onBuyNow: (product: Product) => void
  primaryColor: string
}

export function ProductCard({ product, onBuyNow, primaryColor }: ProductCardProps) {
  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        padding: "16px",
        margin: "8px 0",
        backgroundColor: "#ffffff",
      }}
    >
      {(product.imageUrl || product.images?.[0]) && (
        <img
          src={product.imageUrl || product.images[0]}
          alt={product.name}
          style={{
            width: "100%",
            height: "120px",
            objectFit: "cover",
            borderRadius: "6px",
            marginBottom: "12px",
          }}
        />
      )}
      <h3
        style={{
          fontSize: "16px",
          fontWeight: "600",
          margin: "0 0 8px 0",
          color: "#1f2937",
        }}
      >
        {product.name}
      </h3>
      <p
        style={{
          fontSize: "14px",
          color: "#6b7280",
          margin: "0 0 12px 0",
          lineHeight: "1.4",
        }}
      >
        {product.description}
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span
          style={{
            fontSize: "18px",
            fontWeight: "700",
            color: primaryColor,
          }}
        >
          {product.currency} {product.price}
        </span>
        <button
          onClick={() => onBuyNow(product)}
          style={{
            backgroundColor: primaryColor,
            color: "white",
            border: "none",
            borderRadius: "6px",
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: "500",
            cursor: "pointer",
          }}
        >
          Buy Now
        </button>
      </div>
    </div>
  )
}